import styled, { css } from 'styled-components';
import { AngleIcon } from '@/components/UI/Icons/Icons';

export const ProfileMenuBtnWrapper = styled.div`
  position: relative;
`;

export const ProfileMenuBtnBox = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  gap: 10px;
  padding: 10px 15px;
  border-radius: 14px;
  height: 44px;
  cursor: pointer;
  background: ${({ theme }) => theme.palette.secondary.background};
  z-index: 10;
  transition: 0.1s linear;

  &:hover {
    background: ${({ theme }) => theme.palette.tertiary.background};
  }
`;

export const ProfileMenuAngleIcon = styled(AngleIcon)<{
  $isDropdownOpen: boolean;
}>`
  color: ${({ theme }) => theme.palette.primary.labels};

  ${({ $isDropdownOpen }) =>
    $isDropdownOpen &&
    css`
      transform: rotate(180deg);
    `};
`;
